import { useBranding } from '../../features/branding';
import { cn } from '../../lib/utils';

interface AppLogoProps {
  className?: string;
  iconClassName?: string;
  showName?: boolean;
  nameClassName?: string;
}

/**
 * AppLogo — Reusable branding logo component
 * Uses organization logo from branding context with Atriva SVG fallback.
 */
export function AppLogo({
  className,
  iconClassName,
  showName = false,
  nameClassName,
}: AppLogoProps) {
  const { branding } = useBranding();
  const hasLogo = Boolean(branding.logoUrl);
  const shouldRemoveLogoBackground = hasLogo && branding.logoUrl !== '/logo-white.png';
  const logoIconClassName = shouldRemoveLogoBackground
    ? iconClassName
        ?.split(' ')
        .filter((className) => !className.startsWith('bg-'))
        .join(' ')
    : iconClassName;

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div
        className={cn(
          'flex shrink-0 items-center justify-center rounded-lg',
          logoIconClassName,
        )}
      >
        {hasLogo ? (
          <img
            src={branding.logoUrl}
            alt={branding.organizationName}
            className="h-full w-full object-contain p-1"
          />
        ) : (
          <svg
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-full w-full p-1 text-white"
          >
            <path
              d="M4 24L10 8L16 18L22 12L28 24"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 28H28"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        )}
      </div>
      {showName && (
        <span className={cn('font-bold', nameClassName)}>
          {branding.organizationName}
        </span>
      )}
    </div>
  );
}
